var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var s0 = _vm.__get_style([_vm.finalEmptyViewStyle])
  var g0 = _vm.emptyViewImg.length
  var s1 = !g0 ? _vm.__get_style([_vm.emptyViewImgStyle]) : null
  var s2 = !!g0 ? _vm.__get_style([_vm.emptyViewImgStyle]) : null
  var s3 = _vm.__get_style([_vm.emptyViewTitleStyle])
  var s4 = _vm.showEmptyViewReload
    ? _vm.__get_style([_vm.emptyViewReloadStyle])
    : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        s0: s0,
        g0: g0,
        s1: s1,
        s2: s2,
        s3: s3,
        s4: s4,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }